module.exports = {
	"header": "Numéros de téléphone",
	"addPhone": "Ajouter un numéro de téléphone",
	"enterPhone": "Entrer le numéro",
	"removeConfirmation": "Êtes-vous sûr de vouloir retirer <phone /> de vos numéros de téléphone?",
	"successfullyAdded": "Nouveau numéro de téléphone ajouté avec succès",
	"successfullyRemoved": "Numéro de téléphone retiré avec succès"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/phone.json5
// module id = 2005
// module chunks = 6